"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GridContainer = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
const GridContainer = (0, _styled.default)("div")`
    display: ${_ref => {
  let {
    display
  } = _ref;
  return display;
}};
    ${_ref2 => {
  let {
    template
  } = _ref2;
  switch (template?.type) {
    case "auto-fill":
    case "auto-fit":
      return `grid-template-columns: repeat(${template.type}, minmax(${template.minWidth}, 1fr));`;
    case "static":
      return `grid-template-columns: repeat(${template.columns}, ${template.unit || "1fr"});`;
  }
}}
    gap: ${_ref3 => {
  let {
    gap
  } = _ref3;
  return gap;
}}px;
`;
exports.GridContainer = GridContainer;
//# sourceMappingURL=GridContainer.js.map